import script from "./DashboardCustomersStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCustomersStatistics.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCustomersStatistics.vue?vue&type=style&index=0&id=cb16da0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb16da0c"]])

export default __exports__